import { Button, Typography } from "@material-ui/core";
import React, { FC } from "react";

import ActionDialogVariant from "../ActionDialogVariant";
import { useStyles } from "./styles";
import { IDialogTexts } from "./types";

interface IPromptDialogProps {
  isDialogShown: boolean;
  onProceed: () => void;
  onCancel: () => void;
  dialogTexts: IDialogTexts;
  /** 
  Setting to true will make the title colored red
  */
  isWarningTitle?: boolean;
}

const PromptDialog: FC<IPromptDialogProps> = ({
  isDialogShown,
  onProceed,
  onCancel,
  dialogTexts,
  isWarningTitle = false
}) => {
  const classes = useStyles({});
  const titleProps = !isWarningTitle
    ? { defaultTitle: dialogTexts.title }
    : { warningTitle: dialogTexts.title };
  return (
    <ActionDialogVariant
      confirmButtonState="default"
      onClose={onCancel}
      onConfirm={onProceed}
      open={isDialogShown}
      buttonsAlignment="center"
      maxWidth="sm"
      variant="info"
      hideCancelButton
      {...titleProps}
    >
      <Typography className={classes.subContent}>
        {dialogTexts.subTitle}
      </Typography>
      <div className={classes.footerButtonsContainer}>
        <Button
          className={classes.setLaterButton}
          variant="contained"
          onClick={onCancel}
        >
          {dialogTexts.cancelButtonText}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          className={classes.proceedButton}
          onClick={onProceed}
        >
          {dialogTexts.proceedButtonText}
        </Button>
      </div>
    </ActionDialogVariant>
  );
};

export default PromptDialog;
